import { Component, OnInit, ChangeDetectionStrategy , inject} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { PrimeNGConfig } from 'primeng/api';
import { Carga } from '@/app/models/Carga';
import { CargaService } from '@/app/services/carga.service';
import { EquiposService } from '@/app/services/equipos.service';
import { EstacionesService } from '@/app/services/estaciones.service';
import { TokenReaderService } from '@/app/services/security/token-reader.service';
import { DetallesCargaComponent } from '@/app/components/cargas/detalles-carga/detalles-carga.component';
import { CrearCargaComponent } from '@/app/components/cargas/crear-carga/crear-carga.component';
import { PreciosCombustiblesComponent } from '@/app/components/configuraciones/precios-combustibles/precios-combustibles.component';
import { PreciosActuales } from '@/app/models/PrecioCombustible';
import { PreciosService } from '@/app/services/precios.service';
import { DatePipe } from '@angular/common';
import { forkJoin, map, of, switchMap } from 'rxjs';

@Component({
    selector: 'app-cargas',
    templateUrl: './cargas.component.html',
    styleUrls: ['./cargas.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CargasComponent implements OnInit {
  private spinner = inject(NgxSpinnerService);

  //paginacion de api/cargas/BuscarCargas: pageSize se topa en 500 del lado del servidor
  private static readonly PAGE_SIZE = 500;
  //tope de peticiones para no dispararnos con rangos de fechas muy amplios
  private static readonly MAX_PAGINAS = 20;

  //validaciones
  isAdmin: boolean = false;

  //lista de cargas
  lista: Carga[] =[];

  //total de registros que reporta el servidor para la busqueda actual
  totalRegistros: number = 0;

  //listas - dropdown
  estaciones: any[] = [];
  equipos: any[] =[];
  
  //buscador
  SearchCargaRQ = {
    activo: "",
    estacion: this.userTokenReader.getUserData().estacion,
    initDate: new Date(),
    endDate: new Date(),
    page: 1,
    pageSize: CargasComponent.PAGE_SIZE,
  }

  maxDate: Date = new Date();

  badgesPrecios: PreciosActuales[] = [
    {
      precio: 0,
      fechaCreacion: '00/00/00 00:00 A.M',
      tipo: 'MAGNA',
    },
    {
      precio: 0,
      fechaCreacion: '00/00/00 00:00 A.M',
      tipo: 'PREMIUM',
    },
    {
      precio: 0,
      fechaCreacion: '00/00/00 00:00 A.M',
      tipo: 'DIESEL',
    },
  ]

  constructor(
    private cargaService: CargaService,
    private equiposService: EquiposService,
    private estacionesService: EstacionesService,
    private toastr: ToastrService,
    private router: Router,
    private dialog: MatDialog,
    private config: PrimeNGConfig,
    private userTokenReader: TokenReaderService,
    private preciosService: PreciosService,
    private datePipe: DatePipe,
  ){
    this.spinner.show();
    //precios
    this.getPreciosActuales();

    this.SearchCargaRQ.initDate.setDate(this.SearchCargaRQ.initDate.getDate() - 1);

    //cargas 
    this.obtenerEstaciones();
    this.getEquipos(this.userTokenReader.getUserData().estacion);

    //validaciones
    this.isAdmin = this.userTokenReader.isAdmin();

    
  }
  ngOnInit(): void {
    this.config.setTranslation ({
      firstDayOfWeek: 1,
      dayNames: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"],
      dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
      dayNamesMin: ["D", "L", "M", "M", "J", "V", "S"],
      monthNames: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"],
      monthNamesShort: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"],
      today: 'Hoy',
      clear: 'Borrar'
    });
    
  }

  obtenerEstaciones(){
    this.estacionesService.obtenerEstaciones().subscribe({       
      next: (data: any) => {
        if(data != null && data.Estaciones != null){
          this.estaciones = data.Estaciones.filter( (i: any) => i['IATA'] != '').map( (i: any) => {return {'label': i.IATA, 'value': i.IATA} } );    
        }
      },
      error: (err) => {
        if(err.status == 401){
          this.toastr.error('Tu sesión expiró o no tienes permiso para ver esta página.', 'Acceso no autorizado');
          this.router.navigate(['/login']);
        }else{
          //validacion cuando la lista esta vacia
          this.estaciones = [];
          this.SearchCargaRQ.estacion = ""; 
          if(err.error){
            let { ClassInfo } = err.error;
            this.toastr.error(ClassInfo ? ClassInfo.Error : 'Comprueba tu conexión a internet.' , 'Error');
          }
        }
        console.log(err);
      }
    });
  }

  updateListEquipos(event: any){
    if(event != null && event.value != null && event.value !== ""){
      this.getEquipos(event.value);
    }
  }

  getEquipos(station: string){
    this.equiposService.getEquipos(station).subscribe({       
      next: (data: any) => {
        if(data != null && data.Equipos != null){
          this.equipos = data.Equipos.map( (i: any) => {return {'label': i.numeroActivo, 'value': i.numeroActivo} } );    
        }
      },
      error: (err) => {
        if(err.status == 401){
          this.toastr.error('Tu sesión expiró o no tienes permiso para ver esta página.', 'Acceso no autorizado');
          this.router.navigate(['/login']);
        }else{
          this.equipos = [];
          if(err.error){
            let { ClassInfo } = err.error;
            this.toastr.error(ClassInfo ? ClassInfo.Error : 'Comprueba tu conexión a internet.' , 'Error');
          }
        }
        console.log(err);
      }
    });
  }

  getLoads(station: string){
    this.cargaService.getLoads(station).subscribe({       
      next: (data: any) => {
        if(data != null && data.Cargas != null){
          this.lista = data.Cargas;    
        }
        this.spinner.hide();
      },
      error: (err) => {
        this.spinner.hide();
        if(err.status == 401){
          this.toastr.error('Tu sesión expiró o no tienes permiso para ver esta página.', 'Acceso no autorizado');
          this.router.navigate(['/login']);
        }else{
          if(err.error){
            let { ClassInfo } = err.error;
            this.toastr.error(ClassInfo ? ClassInfo.Error : 'Comprueba tu conexión a internet.' , 'Error');
          }
        }
        console.log(err);
      }
    });
  }


  //arma el body que espera api/cargas/BuscarCargas para la pagina indicada
  private construirRequestBusqueda(page: number){
    return {
      activo: this.SearchCargaRQ.activo ?? '',
      estacion: this.SearchCargaRQ.estacion ?? '',
      initDate: this.SearchCargaRQ.initDate,
      endDate: this.SearchCargaRQ.endDate,
      page: page,
      pageSize: this.SearchCargaRQ.pageSize,
    };
  }

  //la respuesta trae Cargas, TotalCount, Page, PageSize y TotalPages
  private obtenerCargasDePagina(data: any): Carga[]{
    return data != null && data.Cargas != null ? data.Cargas : [];
  }

  private obtenerTotalPaginas(data: any): number{
    let totalPaginas = Number(data?.TotalPages ?? data?.totalPages ?? 1);
    if(!Number.isFinite(totalPaginas) || totalPaginas < 1){
      totalPaginas = 1;
    }
    return totalPaginas;
  }

  BuscarCargas(){
    this.spinner.show();
    if(this.SearchCargaRQ.estacion == null){
      this.SearchCargaRQ.estacion = '';
    }

    this.SearchCargaRQ.page = 1;
    this.SearchCargaRQ.pageSize = CargasComponent.PAGE_SIZE;

    let paginasOmitidas = 0;

    this.cargaService.searchLoads(this.construirRequestBusqueda(this.SearchCargaRQ.page)).pipe(
      switchMap((primeraPagina: any) => {
        const cargas = this.obtenerCargasDePagina(primeraPagina);
        const totalPaginas = this.obtenerTotalPaginas(primeraPagina);

        this.totalRegistros = Number(primeraPagina?.TotalCount ?? cargas.length);

        const paginasAConsultar = Math.min(totalPaginas, CargasComponent.MAX_PAGINAS);
        paginasOmitidas = totalPaginas - paginasAConsultar;

        if(paginasAConsultar <= 1){
          return of([cargas]);
        }

        const peticiones = [];
        for(let page = 2; page <= paginasAConsultar; page++){
          peticiones.push(this.cargaService.searchLoads(this.construirRequestBusqueda(page)));
        }

        return forkJoin(peticiones).pipe(
          map((paginas: any[]) => [cargas, ...paginas.map(pagina => this.obtenerCargasDePagina(pagina))])
        );
      })
    ).subscribe({
      next: (paginas: Carga[][]) => {
        this.lista = paginas.reduce((acumulado, pagina) => acumulado.concat(pagina), [] as Carga[]);
        this.SearchCargaRQ.page = 1;
        this.spinner.hide();

        if(paginasOmitidas > 0){
          this.toastr.info(
            `Se muestran los primeros ${this.lista.length} de ${this.totalRegistros} registros. Acorta el rango de fechas para ver el resto.`,
            'Resultados parciales'
          );
        }
      },
      error: (err) => {
        this.spinner.hide();
        if(err.status == 401){
          this.toastr.error('Tu sesión expiró o no tienes permiso para ver esta página.', 'Acceso no autorizado');
          this.router.navigate(['/login']);
        }else{
          if(err.error){
            let { ClassInfo } = err.error;
            this.toastr.error(ClassInfo ? ClassInfo.Error : 'Comprueba tu conexión a internet.' , 'Error');
          }
        }
        console.log(err);
      }
    });
  }


  abrirModalDetallesCarga(modelo: any){
    const dialogRef = this.dialog.open(DetallesCargaComponent, {
      width: '800px',
      height: '740px',
      data: { idCarga: modelo.idCarga },
      panelClass: 'custom-dialog-container',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result.updateList)  this.BuscarCargas();
    });

    this.router.events.subscribe(() => {
      dialogRef.close();
    });
  }

  abrirModalCrearCarga(){
    const dialogRef = this.dialog.open(CrearCargaComponent, {
      width: '800px',
      height: '640px',
      panelClass: 'custom-dialog-container',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result.updateList) this.getLoads(this.userTokenReader.getUserData().estacion);
    });

    this.router.events.subscribe(() => {
      dialogRef.close();
    });
  }


  //configuracion

  abrirModalPreciosCombustibles(){
    const dialogRef = this.dialog.open(PreciosCombustiblesComponent, {
      width: '800px',
      height: '700px',
      panelClass: 'custom-dialog-container',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result.updateList) //actualizar precios
        this.getPreciosActuales(true);
    });

    this.router.events.subscribe(() => {
      dialogRef.close();
    });
  }

  //badges
  
  getPreciosActuales(actualizar: boolean = false){
    this.preciosService.getPreciosActuales().subscribe({
      next: (data: any) => {
        if(data != null && data.PreciosActuales != null){
           data.PreciosActuales.forEach( (element: any) => {
              let selected =  this.badgesPrecios.find( x => x['tipo'] === element['tipo'].toUpperCase());
              if(selected != null){
                selected.fechaCreacion = this.datePipe.transform(element['fechaCreacion'], 'dd/MM/yyyy hh:mm aa')!;
                selected.precio = element['precio'];
              }
           });
        }
        
      
      },
      error: (err) => {
        this.spinner.hide();
        if(err.status == 401){
          this.toastr.error('Tu sesión expiró o no tienes permiso para ver esta página.', 'Acceso no autorizado');
          this.router.navigate(['/login']);
        }else{
          if(err.error){
            let { ClassInfo } = err.error;
            this.toastr.error(ClassInfo ? ClassInfo.Error : 'Comprueba tu conexión a internet.' , 'Error');
          }
        }
        console.log(err);
      },
      complete: () => {
        if(!actualizar)
        this.getLoads(this.userTokenReader.getUserData().estacion);
      }
    });
  }


  getPrecioActual(tipo: string, dato: string){
    let selectedItem = this.badgesPrecios.find(x => x.tipo === tipo.toUpperCase());
    if(selectedItem != null){
      if(dato === 'FECHA'){
        return selectedItem.fechaCreacion;
      }else{
        //PRECIO
        return selectedItem.precio;
      }
    }
    return '';
  }

}
